import React, { useEffect, useState } from "react";
import { Card, CardBody, Form, Badge, Row, Col, Button } from "reactstrap";
import "./DataTable.scss";
import Switch from 'react-switch';

const DataTable = ({
  columns,
  data,
  readOnly = false,
  checkAll,
  recalculaMargemMkp,
  onlyChecked = false,
  setColumn,
  gravaPosicaoColunas,
  title = "Tabela de Dados",
  showHeader = true,
  className = "",
  onChangeSwitch,
  onDoubleClick,
  onSort
}) => {
  const [form, setForm] = useState(data);
  const [draggedColumn, setDraggedColumn] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');

  const handleSort = (field) => {
    const newOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(newOrder);
    onSort && onSort(field, newOrder);
  };

  useEffect(() => {
    setForm(data);
  }, [data]);

  const countSubstr = (string, subString, allowOverlapping) => {
    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  };

  const onChangeInput = (e, idx) => {
    let frm = [...form];
    let value = e.target.value;

    columns.map(col => {
      if (col.datafield == e.target.name) {
        value = value.replace(',', '.');

        if (value.includes('.')) {
          if (countSubstr(value, '.') > 1) {
            value = (value.replace(/[^0-9]/g, '') / 100);
          } else {
            value = value.replace(/[^0-9.]/g, '');
          }
        } else {
          value = value.replace(/[^0-9]/g, '');
        }
      }
    });

    frm[idx][e.target.name] = value;
    setForm(frm);
    recalculaMargemMkp && recalculaMargemMkp();
  };

  const onChangeCB = (e, idx) => {
    let frm = [...form];
    let checked = e.target.checked;
    frm[idx].checked = checked;
    setForm(frm);
  };

  const onChangeCheckAll = (e) => {
    checkAll && checkAll(e.target.checked);
  };

  // Drag and Drop handlers
  const handleDragStart = (e, columnIndex) => {
    setDraggedColumn(columnIndex);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', e.target.outerHTML);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedColumn === null || draggedColumn === dropIndex) return;

    let newCol = [...columns];
    const draggedItem = newCol[draggedColumn];

    // Remove dragged item
    newCol.splice(draggedColumn, 1);

    // Insert at new position
    newCol.splice(dropIndex, 0, draggedItem);

    gravaPosicaoColunas && gravaPosicaoColunas(newCol);
    setColumn && setColumn(newCol);
    setDraggedColumn(null);
  };

  const handleDragEnd = () => {
    setDraggedColumn(null);
  };

  const renderTable = () => (
    <div className="table-responsive">
      <table className="table table-modern mb-0">
        <thead>
          <tr className="table-header-row">
            {columns && columns.map((coluna, idx) => {
              if (coluna.visible !== false) {
                const isCheckbox = coluna.checkbox;
                return (
                  <th
                    key={`col-header-${coluna.datafield}`}
                    style={{
                      width: coluna.width,
                      textAlign: coluna.align || 'center',
                      cursor: 'grab',
                      userSelect: 'none',
                      ...(isCheckbox && {
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        padding: '0.75rem 0.5rem',
                        width: '60px'
                      })
                    }}
                    draggable
                    onDragStart={(e) => handleDragStart(e, idx)}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, idx)}
                    onDragEnd={handleDragEnd}
                    className={`table-header-cell${isCheckbox ? ' checkbox-col' : ''}`}
                  >
                    {coluna.checkbox ? (
                      <div className="form-check d-flex justify-content-center">
                        <input
                          type="checkbox"
                          onChange={onChangeCheckAll}
                          className="form-check-input"
                        />
                      </div>
                    ) : (
                      <div
                        className="header-content"
                        style={{ justifyContent: coluna.align === 'left' ? 'flex-start' : coluna.align === 'right' ? 'flex-end' : 'center', cursor: coluna.sort ? 'pointer' : 'grab' }}
                        onClick={coluna.sort ? () => handleSort(coluna.datafield) : undefined}
                      >
                        <span className="header-text">{coluna.text}</span>
                        {coluna.sort
                          ? <i className={`ml-1 fa ${sortField === coluna.datafield ? (sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'}`} style={{ fontSize: 11 }} />
                          : <i className="fe fe-more-vertical ml-1 drag-handle"></i>
                        }
                      </div>
                    )}
                  </th>
                );
              }
              return null;
            })}
          </tr>
        </thead>
        <tbody>
          {data && data.map((linha, idx) => {
            if (((onlyChecked === true) && (linha.checked)) || (onlyChecked === false)) {
              return (
                <React.Fragment key={`tbody-${idx}`}>
                  {/* Linha principal com dados */}
                  <tr
                    className={`table-row-main table-row-group ${(idx % 2 === 0) ? 'row-even' : 'row-odd'} ${hoveredRow === idx ? 'row-hovered' : ''}`}
                    data-row-group={idx}
                    onMouseEnter={() => setHoveredRow(idx)}
                    onMouseLeave={() => setHoveredRow(null)}
                    onDoubleClick={() => onDoubleClick(linha.id)}
                  >
                    {columns.map((col, colIdx) => {
                      if (col.visible !== false) {
                        const isCheckbox = col.checkbox;
                        return (
                          <td
                            key={`col-${colIdx}`}
                            style={{
                              width: col.width,
                              textAlign: col.align || 'center',
                              ...(isCheckbox && {
                                textAlign: 'center',
                                verticalAlign: 'middle',
                                padding: '0.75rem 0.5rem',
                                width: '60px'
                              })
                            }}
                            className={`table-cell-modern${isCheckbox ? ' checkbox-col' : ''}`}
                          >
                            {(col.editable && !readOnly && linha.checked) ? (
                              <Form.Control
                                name={col.datafield}
                                value={((col.currency && linha[columns[colIdx].datafield] != "") ? 'R$ ' : '') + linha[columns[colIdx].datafield]}
                                style={{ textAlign: col.align || 'center' }}
                                onChange={(e) => onChangeInput(e, idx)}
                                size="sm"
                                className="form-control-modern"
                              />
                            ) : (
                              col.checkbox ? (
                                <div className="form-check d-flex justify-content-center">
                                  <input
                                    type="checkbox"
                                    onChange={(evt) => onChangeCB(evt, idx)}
                                    checked={linha.checked}
                                    className="form-check-input"
                                  />
                                </div>
                              ) : (
                                <div className="cell-content" style={{ textAlign: col.align || 'center' }}>
                                  {col.formatter
                                    ? col.formatter(linha[col.datafield], linha)
                                    : (
                                      <>
                                        {col.currency && (
                                          <span className="currency-value">
                                            R$ {linha[col.datafield]}
                                          </span>
                                        )}
                                        {col.sufix && (
                                          <span className="sufix-value">
                                            {linha[col.datafield]} {col.sufix}
                                          </span>
                                        )}
                                        {!col.sufix && !col.currency && !col.switch && (
                                          <span className="regular-value">
                                            {linha[col.datafield]}
                                          </span>
                                        )}
                                        {col.switch && (
                                          <Switch
                                            className="react-switch"
                                            height={15}
                                            width={35}
                                            checked={linha[col.datafield] == 'S'}
                                            onChange={(e) => { onChangeSwitch(linha.id, e) }}
                                            onColor='#6bd098'
                                          />
                                        )}
                                      </>
                                    )
                                  }
                                </div>
                              )
                            )}
                          </td>
                        );
                      }
                      return null;
                    })}
                  </tr>

                  {/* Linha secundária com informações do produto */}
                  {(linha.fornecedor1 || linha.apresentacao1) && (
                    <tr
                      className={`table-row-product-info table-row-group ${(idx % 2 === 0) ? 'row-even' : 'row-odd'} ${hoveredRow === idx ? 'row-hovered' : ''}`}
                      data-row-group={idx}
                      onMouseEnter={() => setHoveredRow(idx)}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      <td colSpan={columns.filter(col => col.visible !== false).length} className="product-info-cell">
                        <div className="product-info-content">
                          {linha.fornecedor && (
                            <div className="product-name ">
                              <i className="fe fe-package mr-2"></i>
                              <strong>Fornecedor/Favorecido:</strong> {linha.fornecedor}
                            </div>
                          )}
                          {linha.fantasia && (
                            <div className="product-presentation">
                              <i className="fe fe-info mr-2"></i>
                              <strong>Loja:</strong> {linha.fantasia}
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            }
            return null;
          })}
        </tbody>
      </table>
    </div>
  );

  const renderContent = () => (
    <div className="datatable-content">
      {renderTable()}
    </div>
  );

  return (
    <div className={`data-table-container ${className}`}>
      {showHeader ? (
        <Card className="datatable-card">
          <CardBody className="datatable-card-body">
            {/* <div className="datatable-header d-flex justify-content-between"> */}
              {/* <h6 className="datatable-title">{title}</h6> */}
              <div className="datatable-actions">
                {/* <div
                  // color="primary" 
                  className="datatable-badge"
                  >
                  {'Total Selecionado R$ ' +
                    data.filter(item => item.pagar == 'S')
                      .map(item => { let valor = item.contpag_valor; return valor })
                      .map(item => { let valor = item.replace(/[^0-9,]/g, '').replace(',', '.'); return valor })
                      .reduce((acumulador, val) => Number(acumulador) + Number(val), 0)
                      .toFixed(2)
                      .replace('.', ',')
                  } */}
                  {/* {data ? data.length : 0} registros */}
                  {/* {data.filter(item => item.pagar == 'S').length} Registros  {(data.filter(item => item.pagar == 'S')
                                                                                   .map(item => {let valor = item.contpag_valor; return valor})
                                                                                  .map(item2 => {let valor = item2.replace('\[^0-9]\g ', ''); return valor})
                                                                                  //  .reduce((acumulador, val) =>  acumulador + val , 0)
                                                                                   
                  )} */}
                  {/* {data.filter(item => item.pagar == 'S' ? item.contpag_valor : 0).reduce((acumulador, val) => acumulador + val , 0)} */}
                {/* </div> */}
              </div>
              {/* <div className="w-25"
              // className="pl-0"
              >
                <Button
                  // disabled={countSelectPagar() > 0 ? false : true}
                  block
                  className="m-0 w-100 d-block"
                  color="info"
                  style={{ padding: '7px' }}
                  // onClick={() => pagarEmMassa()}
                >
                  <i className="fa-solid fas fa-check" />
                  Pagar
                  
                </Button>
              </div> */}
            {/* </div> */}  
            {renderContent()}
          </CardBody>
        </Card>
      ) : (
        renderContent()
      )}
    </div>
  );
};

export default DataTable; 